var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAdminLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.139 4.5868C17.4017 4.26658 17.8743 4.21997 18.1945 4.4827C19.3062 5.39481 20.2017 6.54216 20.8166 7.84208C21.4314 9.142 21.7502 10.5621 21.75 12.0001L21 12L21.75 12.0001C21.75 17.3831 17.383 21.75 12 21.75C6.61745 21.75 2.25065 17.3836 2.25004 12.0011C2.24594 10.5683 2.55772 9.15207 3.16319 7.85338C3.76882 6.55434 4.6534 5.40481 5.75395 4.48663C6.07201 4.22128 6.54495 4.264 6.81031 4.58206C7.07566 4.90011 7.03294 5.37306 6.71488 5.63842C5.78365 6.41534 5.03515 7.38802 4.5227 8.4872C4.01024 9.58638 3.74643 10.785 3.75004 11.9978L3.75004 12C3.75004 16.5546 7.4455 20.25 12 20.25C16.5546 20.25 20.25 16.5546 20.25 12V11.9999C20.2502 10.7838 19.9806 9.58279 19.4606 8.48342C18.9406 7.38406 18.1833 6.41372 17.2431 5.64234C16.9228 5.37961 16.8762 4.90703 17.139 4.5868Z",
    fill: "#21272A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.25C12.4142 2.25 12.75 2.58579 12.75 3V12C12.75 12.4142 12.4142 12.75 12 12.75C11.5858 12.75 11.25 12.4142 11.25 12V3C11.25 2.58579 11.5858 2.25 12 2.25Z",
    fill: "#21272A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAdminLogout);
export default __webpack_public_path__ + "static/media/ic_admin_logout.f85b6a8f9d0a688f957e3469e255c697.svg";
export { ForwardRef as ReactComponent };